<template>
  <sa-page-layout :btnBackVisible="false" :btnEditVisible="false" :btnRefreshVisible="false" :linkback="linkback" :pathResource="pathResource">
    <!-- <template #toolbar>
      <b-button class="float-sm-right primary" variant="info btn-toolbar" size="sm" @click="onRefresh" v-b-modal.modal-center>
        <b-icon icon="arrow-clockwise" />
        {{ getLabelTraduora("global.lblBtnRefresh") }}
      </b-button></template
    > -->
    <template slot="table-body">
      <RsaDynamicBodyAreaComponent ref="cmpRsaDynamicBodyAreaComponent"></RsaDynamicBodyAreaComponent>
    </template>
  </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaDynamicBodyAreaComponent from "../components/RsaDynamicBodyAreaComponents.vue";

export default {
  mixins: [UtilityMixin],
  components: { SaPageLayout, RsaDynamicBodyAreaComponent },
  data() {
    return {
      pathResource: "/rsaaree",
      linkback: null,
    };
  },
  mounted() {
    // let me = this;
  },
  methods: {
    onRefresh() {
      this.$refs.cmpRsaDynamicBodyAreaComponent.init();
    },
    test() {
      console.log("REALOAD");
    },
  },
};
</script>
<style scoped></style>
